<script setup>
import appQrCode from '~/assets/images/homepage/app/get-the-app-qr.svg';

const { $tracking } = useNuxtApp();

const getTheAppUrl = computed(() => {
  return 'https://hostelworld.onelink.me/IdiK/lvf4jssn';
});

const getTheAppQrCode = computed(() => {
  return appQrCode;
});

// ### METHODS
function onQRButtonClick() {
  const ref = document.getElementById('download-section');
  if (ref && ref?.getBoundingClientRect) {
    scrollTo(0, ref.getBoundingClientRect().top);
  }
}
</script>

<template>
  <div>
    <nuxt-link
      class="badge-wrapper"
      :href="getTheAppUrl"
      rel="noopener noreferrer"
      target="_blank"
      title="Get the App"
      @click="$tracking.onAppDownloadClick()"
    >
      <div
        role="dialog"
        class="badge"
        aria-label="Get the App"
      >
        <img
          alt="Get the App icon"
          width="24"
          height="24"
          loading="lazy"
          src="https://a.hwstatic.com/image/upload/v1644942643/pwa/sp/hw-icon.svg"
        />
        <span>Get the App</span>
      </div>
    </nuxt-link>

    <div
      role="dialog"
      class="gta-fixed-wrapper"
      aria-label="Get the App"
      @click="onQRButtonClick"
    >
      <img
        alt="Get the App QR"
        class="app-qr-code small"
        width="72"
        height="72"
        loading="lazy"
        :src="getTheAppQrCode"
      />
      <img
        alt="Get the App QR"
        class="app-qr-code large"
        width="124"
        height="124"
        loading="lazy"
        :src="getTheAppQrCode"
      />
      <div class="text">
        Get the App
      </div>
    </div>

    <div class="badge-placeholder" />
  </div>
</template>

<style lang="scss" scoped>
.badge {
  // positioning
  position: fixed;
  bottom: $wds-spacing-m;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;

  // layout
  display: flex;
  align-items: center;
  padding: wds-rem(12px);

  // Colors
  color: $wds-color-white;
  background-color: $wds-color-purple;
  border-radius: $wds-border-radius-m;
  box-shadow: $wds-shadow-light-xl;

  // Font
  @include title-6-bld;

  line-height: wds-rem(20px);

  & img {
    margin-right: $wds-spacing-s;
  }
}

.gta-fixed-wrapper {
  // positioning
  position: fixed;
  bottom: $wds-spacing-m;
  right: $wds-spacing-m;
  z-index: $wds-z-index-overlay;

  // layout
  max-width: wds-rem(140px);
  width: fit-content;
  height: wds-rem(88px);
  padding: $wds-spacing-s;
  box-shadow: $wds-shadow-light-xl;
  background-color: $wds-color-purple;
  border-radius: $wds-border-radius-m;
  color: $wds-color-teal-light;

  // Font
  @include title-6-bld;

  line-height: wds-rem(20px);

  // Animation
  display: none;
  transform: translateY(120%);
  animation: appear 0.3s 0.5s linear forwards;

  @keyframes appear {
    0% {
      transform: translateY(120%);
    }

    100% {
      transform: translateY(0);
    }
  }

  svg {
    fill: $wds-color-white;
    stroke: $wds-color-white;
    height: 100%;
  }

  .text {
    display: flex;
    align-items: center;
    width: wds-rem(44px);
    word-spacing: wds-rem(44px);
    color: $wds-color-white;
  }

  .app-qr-code {
    &.small {
      display: inline-block;
    }

    &.large {
      display: none;
    }
  }

  &:hover {
    height: wds-rem(140px);
    cursor: none;

    .text {
      display: none;
    }

    .app-qr-code {
      &.small {
        display: none;
      }

      &.large {
        display: inline-block;
      }
    }
  }
}

@include desktop {
  .badge {
    display: none;
  }

  .gta-fixed-wrapper {
    display: flex;
    gap: $wds-spacing-s;
  }
}
</style>
